<template>
  <div style="position: relative">
    <!-- 左侧图例 -->
    <div
      v-if="showCompany === 1 || zoomNow > 8"
      class="legend"
      :style="{ 'max-height': detailHeight + 150 + 'px' }"
    >
      <p class="legend_title">图例</p>
      <template v-for="item in showAll ? legendOptions : selectOptions">
        <div :key="item.id" class="legend_li">
          <p class="square" :style="{ backgroundColor: item.bgColor }"></p>
          <p class="txt">{{ item.name }}</p>
        </div>
      </template>
    </div>
    <!-- 右侧选择 -->
    <div
      style="
        text-align: right;
        margin-right: 30px;
        position: absolute;
        z-index: 10;
        top: 20px;
        right: 20px;
        margin-bottom: 10px;
      "
    >
      <el-radio-group
        style="margin-right: 20px; margin-top: -2px"
        v-model="showCompany"
        size="small"
        @change="changeSelect"
      >
        <el-radio-button :label="1">企业产能</el-radio-button>
        <el-radio-button :label="2">区域汇总</el-radio-button>
      </el-radio-group>
      <el-select
        v-model="selectTypes"
        multiple
        collapse-tags
        size="small"
        placeholder="请选择种类"
      >
        <el-option
          v-for="item in legendOptions"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
      <el-button type="primary" size="small" @click="changeSelect"
        >确认</el-button
      >
    </div>
    <!-- 地图 -->
    <div class="echartLeft" style="margin-top: -24px">
      <div id="container" style="height: 500px"></div>
    </div>
    <!-- 详情 -->
    <div class="content">
      <div
        class="detail"
        v-if="detailLlag && canShowDetailDetail === 0"
        :style="{ 'max-height': detailHeight + 'px' }"
      >
        <div class="detail_li detail_title" ref="detailTitle">
          <img
            @click="closeDetail"
            src="../../../assets/images/confirm.png"
            alt=""
          />
          <div class="info_title">
            <p>{{ verneCompanyDetail.title.name }}：</p>
            <p>{{ verneCompanyDetail.title.value }}</p>
          </div>
        </div>
        <div class="detail_li detail_main" ref="detailMain">
          <template v-for="(item, index) in verneCompanyDetail.tableColumns">
            <div
              :key="item.id"
              :class="[
                index === verneCompanyDetail.tableColumns.length - 1
                  ? 'bom'
                  : 'top',
              ]"
            >
              <div class="info_label">
                <span>{{ item.name }}</span>
                <span v-if="item.unit">（{{ item.unit }}）</span>
              </div>
              <div class="info_value" v-html="item.value"></div>
            </div>
          </template>
          <template v-if="verneCompanyDetail.otherColumns">
            <template v-for="item in verneCompanyDetail.otherColumns">
              <p
                v-if="!item.prop || verneCompanyInfo[item.prop].length > 0"
                :key="item.id"
                style="padding: 6px 0"
              >
                {{ item.name }}
              </p>
              <template v-if="item.prop">
                <template
                  v-for="(citem, cindex) in verneCompanyInfo[item.prop]"
                >
                  <p
                    v-if="cindex !== 0"
                    :key="citem.id"
                    style="padding: 6px 0"
                  ></p>
                  <template v-for="(ditem, dindex) in item.columns">
                    <div
                      :key="citem.id + ditem.prop"
                      :class="[
                        dindex === item.columns.length - 1 ? 'bom' : 'top',
                      ]"
                    >
                      <div class="info_label">
                        <span>{{ ditem.label }}</span>
                        <span v-if="ditem.unit">（{{ ditem.unit }}）</span>
                      </div>
                      <div class="info_value" v-html="citem[transformName(ditem.prop)]"></div>
                    </div>
                  </template>
                </template>
              </template>
              <template v-else>
                <template v-for="(citem, cindex) in item.columns">
                  <div
                    :key="citem.prop"
                    :class="[
                      cindex === item.columns.length - 1 ? 'bom' : 'top',
                    ]"
                  >
                    <div class="info_label">
                      <span>{{ citem.label }}</span>
                      <span v-if="citem.unit">（{{ citem.unit }}）</span>
                    </div>
                    <div class="info_value" v-html="citem.value"></div>
                  </div>
                </template>
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
import * as _ from "lodash";
import {
  steelMapDetail,
  cokeMapDetail,
  coalMapDetail,
  powerCoalMapDetail,
  companyDetail,
} from "@/api/map";
import $ from "jquery";
import { dataConfig, legendOptions, typeOptions } from "../config";
import { transformName } from "@/utils/ruoyi";

export default {
  data() {
    return {
      transformName: transformName,
      mapM: null,
      mapCenter: null,
      markers: [], //所有点
      zoomNow: 5,
      oneB: [
        {
          name: "北京市",
          center: "116.405285,39.904989",
          type: 0,
          subDistricts: [],
        },
      ],
      selectTypes: [],
      showCompany: 1,
      allCompnays: null,
      markertNow: [], //选中的红
      markertNowPOsition: null, // 选中的位置
      canShowDetailDetail: 1, // 是否有权限查看  1 不显示  0 显示
      //选中的某坐标
      companys: [],
      provinceCompanys: [],
      verneCompanyDetail: {},
      verneCompanyInfo: {},
      detailLlag: false,
      showAll: true,
      selectOptions: [],
      detailHeight: 100,
      legendOptions: legendOptions, // 图例数据
      typeOptions: typeOptions, // 类型数据
      dataConfig: dataConfig, // 详情数据
      mass: null,
      massCheck: null,
      checkInfo: null,
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      let dHeight = $(window).height() - 170;
      $("#container").height(dHeight + "px");
      this.detailHeight = dHeight - 100;
      this.mapCenter = new AMap.LngLat(116.397428, 39.90923);
      this.mapM = new AMap.Map("container", {
        zoom: this.zoomNow,
      });
      // 地图控件
      // AMap.plugin(['AMap.ToolBar'], () => {
      //   this.mapM.addControl(new AMap.ToolBar({
      //     map: this.mapM
      //   }));
      // });
      this.maker();
      this.mapM.on("zoomend", () => {
        let zoom = this.mapM.getZoom();
        //关联点出现不监听
        this.getZoomData(zoom);
      });
    },
    /**
     * 确认选择下拉框
     */
    changeSelect() {
      let selectOptions = [];
      if (this.selectTypes.length > 0) {
        this.showAll = false;
        this.legendOptions.forEach((item) => {
          if (this.selectTypes.indexOf(item.name) != -1) {
            selectOptions.push(item);
          }
        });
      } else {
        this.showAll = true;
      }
      this.selectOptions = selectOptions;
      this.getAllCompanys();
      this.closeDetail();
    },
    /**
     * 获取地图点位
     */
    maker() {
      let that = this;
      AMapUI.loadUI(["geo/DistrictExplorer"], function (DistrictExplorer) {
        initPage(DistrictExplorer);
      });

      function initPage(DistrictExplorer) {
        //创建一个实例
        var districtExplorer = new DistrictExplorer({
          map: that.mapM, //关联的地图实例
        });

        var adcode = 100000; //全国的区划编码

        districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }

          //绘制载入的区划节点
          renderAreaNode(districtExplorer, areaNode);
        });
      }

      function renderAreaNode(districtExplorer, areaNode) {
        //清除已有的绘制内容
        districtExplorer.clearFeaturePolygons();

        //just some colors
        var colors = [
          "#3366cc",
          "#dc3912",
          "#ff9900",
          "#109618",
          "#990099",
          "#0099c6",
          "#dd4477",
          "#66aa00",
        ];

        //绘制子级区划
        districtExplorer.renderSubFeatures(areaNode, function (feature, i) {
          var fillColor = colors[i % colors.length];
          var strokeColor = colors[colors.length - 1 - (i % colors.length)];

          return {
            cursor: "default",
            bubble: true,
            strokeColor: strokeColor, //线颜色
            strokeOpacity: 1, //线透明度
            strokeWeight: 1, //线宽
            fillColor: fillColor, //填充色
            fillOpacity: 0.35, //填充透明度
          };
        });

        //绘制父级区划，仅用黑色描边
        districtExplorer.renderParentFeature(areaNode, {
          cursor: "default",
          bubble: true,
          strokeColor: "black", //线颜色
          fillColor: null,
          strokeWeight: 3, //线宽
        });

        //更新地图视野以适合区划面
        that.mapM.setFitView(districtExplorer.getAllFeaturePolygons());
      }

      this.changeSelect();
    },
    /**
     * 获取地图数据
     */
    getAllCompanys() {
      const rLoading = this.openLoading();
      const routerPath = this.$route.path.split("/")[1];
      const params = {
        type: this.selectTypes.join(","),
        showCompany: this.showCompany,
        mapFlag: 2,
      };
      const axo =
        routerPath === "coke"
          ? cokeMapDetail(params)
          : routerPath === "coal"
          ? coalMapDetail(params)
          : routerPath === "steel"
          ? steelMapDetail(params)
          : routerPath === "powerCoal"
          ? powerCoalMapDetail(params)
          : cokeMapDetail(params);
      axo
        .then((suc) => {
          if (suc["data"]) {
            //区域汇总： 中国展示省时  其他国家还是展示国家
            if (suc["data"].countriesInfo && suc["data"].provincesInfo) {
              suc["data"].provincesInfo = JSON.parse(
                JSON.stringify([
                  ...suc["data"].provincesInfo,
                  ...suc["data"].countriesInfo,
                ])
              );
              // 去掉中国的
              const findIndex = suc["data"].provincesInfo.findIndex(
                (item) => item.country === "中国"
              );
              suc["data"].provincesInfo.splice(findIndex, 1);
            }
            this.allCompnays = suc["data"];
            this.getZoomData(this.zoomNow);
          } else {
            this.$message.info("暂无数据");
          }
          rLoading.close();
        })
        .catch((err) => {
          rLoading.close();
        });
    },
    //根据级别显示数据
    getZoomData(zoom) {
      this.zoomNow = zoom;
      if (!this.allCompnays || this.allCompnays.length === 0) return;
      if (this.showCompany === 1) {
        // 企业产能
        this.companys = this.allCompnays[`companysInfo`]; //
        this.setMap();
      } else {
        // 区域汇总
        if (_.includes([0, 1, 2, 3], zoom)) {
          if (this.allCompnays[`continentsInfo`]) {
            this.provinceCompanys = this.allCompnays[`continentsInfo`];
            this.setNoDetailMap("continent");
          } else {
            this.provinceCompanys = this.allCompnays[`countriesInfo`];
            this.setNoDetailMap("country");
          }
        } else if (_.includes([4], zoom)) {
          this.provinceCompanys = this.allCompnays[`countriesInfo`];
          this.setNoDetailMap("country");
        } else if (_.includes([5, 6], zoom)) {
          this.provinceCompanys = this.allCompnays[`provincesInfo`];
          this.setNoDetailMap("province");
        } else if (_.includes([7, 8], zoom)) {
          this.provinceCompanys = this.allCompnays[`citysInfo`];
          this.setNoDetailMap("city");
        } else if (zoom > 8) {
          this.companys = this.allCompnays[`companysInfo`]; //
          this.setMap();
        }
      }
    },
    // 标注北京
    addBeijing() {
      let marker1;
      let icon1 = new AMap.Icon({
        image: require("@/assets/map/redXing.png"),
        size: new AMap.Size(24, 24),
      });
      marker1 = new AMap.Marker({
        icon: icon1,
        position: this.oneB[0].center.split(","),
        offset: new AMap.Pixel(-12, -12),
        zIndex: 101,
        title: this.oneB[0].name,
        map: this.mapM,
      });
      this.markers.push(marker1);
    },
    /**
     * 省市汇总
     * @param str
     */
    setNoDetailMap(str) {
      this.clearPoint();
      this.addBeijing();
      //tbule  省 市
      if (this.provinceCompanys) {
        for (var i = 0; i < this.provinceCompanys.length; i++) {
          let company = this.provinceCompanys[i];
          if (company.lat != null && company.lng != null) {
            const title =
              str === "province"
                ? company[`${str}`]
                  ? company[`${str}`]
                  : company["country"]
                : company[`${str}`];
            this.clickYuanHidden(
              company.lng,
              company.lat,
              title,
              company[`capacity`],
              company["varietiesList"]
            );
          }
        }
      }
      this.mapM.setZoomAndCenter(this.zoomNow);

      //this.mapM.setFitView();//地图自适应
    },
    /**
     * 设置地图
     */
    setMap() {
      this.clearPoint();
      this.addBeijing();
      // 标点样式
      let style = [];
      this.legendOptions.forEach((item) => {
        style.push({
          url: item.icon,
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(17, 28),
        });
      });
      let citys = [];
      // 点位信息
      for (var i = 0; i < this.companys.length; i++) {
        let company = this.companys[i];
        if (company.lat != null && company.lng != null) {
          const findItem = this.legendOptions.find(
            (item) =>
              company.varieties.indexOf(item.name) !== -1 ||
              company.varieties.indexOf(item.alias) !== -1
          );
          citys.push({
            lnglat: [company.lng, company.lat],
            name: company.companyName,
            company: company,
            style: findItem.id - 1,
          });
        }
      }
      // 标点
      const that = this;
      try {
        that.mass = new AMap.MassMarks(citys, {
          zIndex: 111,
          cursor: "pointer",
          style: style,
        });
        var marker = new AMap.Marker({ content: " ", map: that.mapM });
        that.mass.on("mouseover", function (e) {
          marker.setPosition(e.data.lnglat);
          marker.setLabel({ content: e.data.name });
        });
        that.mass.on("mouseout", function (e) {
          marker.setLabel({ content: "" });
        });
        that.mass.on("click", (e) => {
          const company = e.data.company;
          if (
            that.checkInfo &&
            company.companyCode === that.checkInfo.companyCode &&
            company.varieties === that.checkInfo.varieties
          )
            return;
          that.getOneDetail(company);
          that.checkInfo = company;
        });
        that.mass.setMap(that.mapM);
      } catch (error) {
        console.log(error);
      }
      if (this.checkInfo) {
        this.getOneDetail(this.checkInfo);
      }
      this.mapM.setZoomAndCenter(this.zoomNow);

      //this.mapM.setFitView();//地图自适应
    },
    clickYuanHidden(lng, lat, str, capacity, varietiesList) {
      let iconM = new AMap.Icon({
        image: require("@/assets/map/mark_zi.png"),
        size: new AMap.Size(24, 24),
      });
      let marker = new AMap.Marker({
        icon: iconM,
        position: [lng, lat],
        title: str,
        map: this.mapM,
      });
      let markerContent = document.createElement("div");
      markerContent.className = "markerDiv";
      markerContent.style.backgroundColor = "#3072f7";
      markerContent.style.borderRadius = "50%";
      markerContent.style.height = "110px";
      markerContent.style.width = "110px";
      markerContent.style.wordBreak = "break-all";
      markerContent.style.textAlign = "center";
      markerContent.style.padding = "5px";
      markerContent.style.boxShadow = "#5d5d5d 0px 0px 4px 0px";
      markerContent.style.display = "table";
      let tempstr = "";
      varietiesList.map((item) => {
        tempstr += `${item["varieties"]} : ${
          item["sum"] ? parseInt(item["sum"]) : 0
        }   `;
      });
      markerContent.title = tempstr;
      let testContent = document.createElement("div");
      testContent.className = "markerDivText";
      testContent.style.wordBreak = "break-all";
      testContent.style.textAlign = "center";
      testContent.style.display = "table-cell";
      testContent.style.verticalAlign = "middle";
      markerContent.appendChild(testContent);

      // 点标记中的文本
      var markerSpan = document.createElement("p");
      markerSpan.className = "marker";
      markerSpan.innerHTML = str;
      markerSpan.style.position = "relative";
      markerSpan.style.color = "#ffffff";
      markerSpan.style.padding = "9px 10px 0 10px";
      markerSpan.style.whiteSpace = "break-word";
      markerSpan.style.fontSize = "12px";
      markerSpan.style.fontWeight = "600";
      // markerSpan.style.display = 'inline-block';
      markerSpan.style.lineHeight = "12px";
      testContent.appendChild(markerSpan);
      for (let i = 0; i <= varietiesList.length - 1; i++) {
        let markerSpan2 = document.createElement("span");
        markerSpan2.className = "marker";
        markerSpan2.innerHTML = `${varietiesList[i]["varieties"]}:${
          varietiesList[i]["sum"] ? parseInt(varietiesList[i]["sum"]) : 0
        }`;
        markerSpan2.style.position = "relative";
        markerSpan2.style.color = "#ffffff";
        markerSpan2.style.padding = "2px 5px 0 5px";
        markerSpan2.style.fontSize = "12px";
        markerSpan2.style.display = "inline-block";
        testContent.appendChild(markerSpan2);
        marker.setContent(markerContent); //更新点标记内容
      }
      marker.on("click", (e) => {
        marker = null;

        this.mapM.remove([lng, lat]);
        this.clickYuanHidden(lng, lat, str, capacity, varietiesList);
      });
      this.markers.push(marker);
    },
    /**
     * 清除点
     */
    clearPoint() {
      if (this.mass) {
        this.mapM.remove(this.mass);
      }
      if (this.zoomNow < 8) {
        this.mapM.remove(this.markertNow);
        this.markertNow = [];
        this.markertNowPOsition = null;
      }
      this.mapM.remove(this.markers);
      this.markers = [];
    },
    // 显示信息
    getOneDetail(company) {
      // 清除之前选中的点
      if (this.massCheck) {
        this.mapM.remove(this.massCheck);
      }
      // 标记新选中的点
      this.addCheckMark(company);
      // 获取所选点的数据
      const findItem = this.typeOptions.find(
        (item) => item.name === company.varieties
      );
      if (!findItem) {
        this.$message.info("暂无数据");
        return;
      }
      const rLoading = this.openLoading();
      let param = {
        companyCode: company.companyCode,
        varieties: company.varieties,
        type: findItem ? findItem.type : "",
      };
      companyDetail(param)
        .then((suc) => {
          if (suc["data"] && suc["data"].length > 0 && suc["data"][1] != null) {
            // 是否有权限显示
            this.canShowDetailDetail = suc["data"][0].show;
            // 将获取的数据处理成config中dataConfig的格式
            const info = suc["data"][1];
            const dataConfig = JSON.parse(JSON.stringify(this.dataConfig))[
              findItem.prop
            ];
            dataConfig.title["value"] =
              info[transformName(dataConfig.title.prop)];
            dataConfig.tableColumns.forEach((item) => {
              let value = "";
              if (item.row) {
                item.row.forEach((citem) => {
                  value = setValue(citem, value, info);
                });
              } else {
                value = setValue(item, value, info);
              }
              item["value"] = value
                ? value.replace(/(^\s*)|(\s*$)/g, "").replace(/^\/|\/$/g, "")
                : "";
            });
            if (dataConfig.otherColumns) {
              dataConfig.otherColumns.forEach((item) => {
                if (!item.prop) {
                  item.columns.forEach((citem) => {
                    let value = "";
                    value = setValue(citem, value, info);
                    citem["value"] = value
                      ? value
                          .replace(/(^\s*)|(\s*$)/g, "")
                          .replace(/^\/|\/$/g, "")
                      : "";
                  });
                }
              });
            }
            this.verneCompanyInfo = info;
            this.verneCompanyDetail = dataConfig;
            this.detailLlag = true;
            if (this.canShowDetailDetail === 0) {
              this.$nextTick(() => {
                try {
                  const topH =
                    this.$el.querySelector(".detail_title").clientHeight;
                  this.$refs.detailMain.style.maxHeight =
                    this.detailHeight - topH - 20 + "px";
                } catch (error) {}
              });
            }
          } else {
            this.$message.info("暂无数据");
          }
          rLoading.close();
        })
        .catch(() => {
          rLoading.close();
        });
      function setValue(item, value, info) {
        if (item.prop) {
          if (item.options) {
            const findItem = item.options.find(
              (v) => v.value === info[transformName(item.prop)]
            );
            if (findItem) {
              value += findItem.label;
            }
          } else {
            value += info[transformName(item.prop)] || "";
            if (item.text) {
              value += item.text;
            }
          }
        } else if (item.text) {
          value += item.text;
        }
        return value;
      }
    },
    /**
     * 添加点
     */
    addCheckMark(company) {
      // 标点样式
      let style = [
        {
          url: require("@/assets/map/mark_r.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(17, 28),
        },
      ];
      let citys = [
        {
          lnglat: [company.lng, company.lat],
          name: company.companyName,
          style: 0,
        },
      ];
      const that = this;
      try {
        that.massCheck = new AMap.MassMarks(citys, {
          zIndex: 111,
          cursor: "pointer",
          style: style,
        });
        that.massCheck.setMap(that.mapM);
      } catch (error) {
        console.log(error);
      }
    },
    closeDetail() {
      this.detailLlag = false;
      this.checkInfo = null;
      // 清除之前选中的点
      if (this.massCheck) {
        this.mapM.remove(this.massCheck);
      }
    },
  },
};
</script>

<style scoped lang="less">
.detail {
  position: absolute;
  top: 70px;
  right: 44px;
  width: 350px;
  background: rgba(255, 255, 255, 0.85);
  color: #000;
  overflow-x: hidden;
  padding-bottom: 20px;

  .detail_title {
    padding: 15px 20px 10px 20px;
  }
  .detail_main {
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: overlay;
  }
  .info_title {
    width: 310px;
    display: flex;
    p:first-child {
      flex-shrink: 0;
    }
  }
  img {
    position: absolute;
    top: 10px;
    right: 6px;
    cursor: pointer;
  }
  p {
    font-size: 16px;
  }

  .top {
    border-bottom: none !important;
  }

  .top,
  .bom {
    border: 1px solid #f4e4e4;
    width: 310px;
    display: flex;
    .info_label {
      width: 150px;
      background: #fdf3f3;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      line-height: 18px;
      padding: 4px 0;
    }
    .info_value {
      flex: 1;
      background: #ffffff;
      text-align: left;
      display: flex;
      align-items: center;
      padding: 0 6px;
      flex-shrink: 0;
    }
  }
}
.legend {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);
  color: #000;
  padding: 10px 30px 10px 20px;
  overflow-x: hidden;
  overflow-y: overlay;
  .legend_title {
    font-size: 16px;
    margin-bottom: 6px;
  }
  .legend_li {
    display: flex;
    align-items: center;
    height: 30px;
    .square {
      width: 16px;
      height: 16px;
      margin-right: 16px;
    }
    .txt {
      line-height: 30px;
    }
  }
}
</style>
